// Put your application javascript here

$(document).ready(function () {
  // Toggle the content visibility when the mobile menu is open.
  $('#mobile-main-menu summary').on('click', function () {
    $('body').toggleClass('bg-beige');
    $('.site-content').toggle();
  });

  $('#mobile-main-menu a').on('click', function () {
    let trigger = $('#mobile-main-menu').attr('open');
    if (trigger == 'open') {
      $('#mobile-main-menu').removeAttr('open');
    }
    $('body').toggleClass('bg-beige');
    $('.site-content').toggle();
  });

  // Handle the Our Services section content.
  let tabs = $('.tab-link');
  // Display a proper tab content.
  tabs.on('click', function () {
    let ths = $(this);
    const prevActiveItem = $('.tab-item.tab-active');
    const prevActiveButton = $('.tab-link.tab-active');
    if (prevActiveButton) {
      prevActiveButton.removeClass('tab-active');
    }
    if (prevActiveItem) {
      prevActiveItem.removeClass('tab-active');
    }
    const nextActiveItemId = ths.attr('data-tab');
    const nextActiveItem = $(nextActiveItemId);
    ths.addClass('tab-active');
    nextActiveItem.addClass('tab-active');
  });


	handleOurWorksSlider()
});



function handleOurWorksSlider() {
	// Handle the Our Works slider.
	const carousel = $('#works-carousel');
	const carouselPrev = carousel.find('.prev');
	const carouselNext = carousel.find('.next');
	const navPanel = carousel.find('.carousel-nav');
	const gallery = $('.gallery');
	let carouselList = carousel.find('.gallery-list');
	let carouselItems = carouselList.find('li');

	if (carouselItems.length < 3) return

	let galleryWidth = carousel.find('.gallery').width(); // Width of the gallery visible frame.
	let itemWidth = 486; // Carousel item width.
	let itemsGap = 20; // The gap between carousel items.
	if (window.outerWidth <= 640) {
		// Proper width and gap values for mobile devices.
		itemWidth = 189;
		itemsGap = 8;
	}
	// The actual gallery width (items + gaps in between).
	let actualGalleryWidth = carouselItems.length * itemWidth + itemsGap * (carouselItems.length - 1);
	let restGaleryWidth = actualGalleryWidth;
	// Visible frame offset in carousel.
	let galleryPosition = 0;
	if (restGaleryWidth - itemsGap < galleryWidth) {
		navPanel.css('display', 'none');
	}
	// Set the proper gallery width for narrow screens.
	if (window.outerWidth <= 1024) {
		carouselList.width(actualGalleryWidth + itemsGap);
	}

	if (actualGalleryWidth < galleryWidth) {
		carouselNext.prop('disabled', true);
	}

	$(window).on('resize', function () {
		galleryWidth = carousel.find('.gallery').width();
		if (window.outerWidth <= 768) {
			// Proper width and gap values for mobile devices.
			itemWidth = 189;
			itemsGap = 8;
			carouselList.css('transform', `translateX(0px)`);
			gallery.scrollLeft(0);
		} else {
			itemWidth = 486;
			itemsGap = 20;
		}
		if (restGaleryWidth - itemsGap < galleryWidth) {
			navPanel.css('display', 'none');
		} else {
			navPanel.css('display', 'block');
		}
		actualGalleryWidth = carouselItems.length * itemWidth + itemsGap * (carouselItems.length - 1);
		galleryEndPosition = -(actualGalleryWidth - galleryWidth);
	});

	carouselPrev.on('click', function () {
		// Number of teoretical visible images.
		const countOfImages = Math.ceil(galleryWidth / itemWidth);
		// New position.
		let newPosition;
		if (countOfImages === carouselItems.length) {
			// New position calculation.
			newPosition = 0;
			carouselNext.prop('disabled', false);
			carouselPrev.prop('disabled', true);
		} else {
			galleryPosition -= 1;
			// rest of the images on the right side
			restGaleryWidth += itemWidth + itemsGap;
			newPosition = galleryPosition * itemWidth + galleryPosition * itemsGap;
			if (galleryPosition === 0) {
				carouselPrev.prop('disabled', true);
			}
			carouselNext.prop('disabled', false);
		}
		carouselList.css('transform', `translateX(-${newPosition}px)`);
	});

	carouselNext.on('click', function () {
		// Number of gaps in the visible frame.
		let gapCounts = Math.ceil(galleryWidth / itemWidth) - 1;
		// Number of teoretical visible images.
		let countOfImages = Math.ceil(galleryWidth / itemWidth);
		// New position.
		let newPosition;
		if (countOfImages === carouselItems.length) {
			// New position calculation.
			newPosition = actualGalleryWidth - galleryWidth - gapCounts * itemsGap;
			carouselNext.prop('disabled', true);
			carouselPrev.prop('disabled', false);
		} else {
			galleryPosition += 1;
			// rest of the images on the right side
			restGaleryWidth -= itemWidth + itemsGap;
			newPosition = galleryPosition * itemWidth + galleryPosition * itemsGap;
			if (restGaleryWidth - itemsGap < galleryWidth) {
				carouselNext.prop('disabled', true);
			}
			carouselPrev.prop('disabled', false);
		}
		carouselList.css('transform', `translateX(-${newPosition}px)`);
	});
}
